// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'



import ModulePreloader from "src/scripts/modules/modulePreloader";
import CustomAnimation from "src/scripts/modules/CustomAnimation";
import Home from "src/scripts/pages/home";
import ModuleNavigation from "src/scripts/modules/moduleNavigation";
import ModuleModal from "src/scripts/modules/moduleModal";

const modulePreloader = new ModulePreloader();
const moduleNavigation = new ModuleNavigation();
const moduleModal = new ModuleModal();
const animations = new CustomAnimation();
const home = new Home();

jQuery(document).ready(function () {

  animations.init();
  home.init();
  moduleNavigation.init();
  moduleModal.init();

  setTimeout(function () {
    modulePreloader.hidePreloaderLogo();
  }, 500);

  setTimeout(function () {
    modulePreloader.hidePreloader();
  }, 1000);
});
